<template>
  <div>
    <div class="header">
      <div class="header_left" @click="toHome">
        <a class="logo">
          <img src="../assets/img/110x72_top_logo@2x.png" alt="" />
        </a>
        <div class="logo_right">
          <img src="../assets/img/340x66_logo@2x.png" alt="" />
        </div>
      </div>
      <div class="header_right">
        <div class="input_container">
          <input
            class="search"
            v-model="keywords"
            @keyup.enter="toSearch"
            type="text"
            placeholder="请输入关键词搜索"
          />
          <img class="input-icon" src="../assets/img/24x24_sousuo.png" alt="" />
          <div class="lineBox"></div>
        </div>
        <div class="phone_container">
          <img class="phoneImg" src="../assets/img/28x28_call.png" alt="" />
          <span class="phone">{{contactData.fax}}</span>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="tab_box">
        <div :data-index="0">
          <div
            class="tabItem"
            :class="0 == tabIndex ? 'tabItem1' : ''"
            :data-index="0"
            @click="toClick(0)"
          >
            首页
          </div>
        </div>
        <div v-for="item in tab" :key="item.sort" :data-index="item.sort">
          <div
            class="tabItem"
            :class="item.sort == tabIndex ? 'tabItem1' : ''"
            :data-index="item.sort"
            @click="toClick(item.sort)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { getHeadBanner, getContactUs } from "@/server/https.js";
export default {
  name: "Header",
  data() {
    return {
      keywords: "",
      tab: [],
      tabIndex: 0,
      contactData: {},
    };
  },
  beforeMount() {
    this.toClick(0);
  },
  mounted() {
    getHeadBanner().then((res) => {
      this.tab = res.data.body.headList;
    });
    getContactUs().then((res) => {
      this.contactData = res.data.body.contactUs;
    });
    //自动创建路由
    for (let route of this.$router.options.routes) {
      let r = {};
      r.name = route.name;
      r.path = route.path;
      // r.img = route.img;
      // r.img1 = route.img1;
      if (route.navRoute) {
        //是否导航菜单路由
        this.routers.push(r);
      }
    }
  },
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      handler(to, from) {
        if (to.path.includes("/home")) {
          this.tabIndex = 0;
        } else if (to.fullPath == "/about") {
          this.tabIndex = 1;
        } else if (to.fullPath == "/news" || to.path.includes("newsDetail")) {
          this.tabIndex = 2;
        } else if (to.fullPath == "/trade" || to.path.includes("tradeDetail")) {
          this.tabIndex = 3;
        } else if (to.fullPath == "/market") {
          this.tabIndex = 4;
        } else if (
          to.fullPath == "/operation" ||
          to.path.includes("operationDetail")
        ) {
          this.tabIndex = 5;
        } else if (
          to.fullPath == "/build" ||
          to.path.includes("buildDetail") ||
          to.path.includes("projectCase")
        ) {
          this.tabIndex = 6;
        } else if (to.fullPath == "/contact") {
          this.tabIndex = 7;
        }
        // 回调函数，两个参数，to：当前的组件，from：上一个组件
        this.activeMenu = to.path; // 给activeMenu重新赋值为当前组件的路由地址
      },
    },
  },
  methods: {
    toSearch() {
      this.$router.push({
        path: "/search",
        query: {
          keywords: this.keywords,
        },
      });
      this.keywords = "";
    },
    toClick(e) {
      //router ≥ v3.1 后 ，回调形式改成promise api了，返回的是promise，如果没有捕获到错误，控制台始终会出现警告。
      this.tabIndex = e;
      localStorage.setItem("tabIndex", e);
      if (e == 0) {
        this.$router.push({
          path: "/home",
        });
      } else if (e == 1) {
        this.$router.push("/about");
      } else if (e == 2) {
        this.$router.push({
          path: "/news",
          query: {
            tabIndex: 0,
          },
        });
      } else if (e == 3) {
        this.$router.push({
          path: "/trade",
        });
      } else if (e == 4) {
        this.$router.push({
          path: "/market",
        });
      } else if (e == 5) {
        this.$router.push({
          path: "/operation",
        });
      } else if (e == 6) {
        this.$router.push({
          path: "/build",
        });
      } else if (e == 7) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    toHome() {
      this.$router.push({
        path: "/home",
      });
    },
  },
};
</script>
    
<style scoped>
.header {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 104px;
  background-color: #ffffff;
}

.header_left {
  display: flex;
  height: 72px;
  margin-left: 120px;
}

.header_left:hover {
  cursor: pointer;
}

.header_right {
  display: flex;
  margin-right: 120px;
  margin-top: 33px;
}

.logo {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-right: 16px;
}

.logo img {
  max-width: 100%;
  width: 110px;
  height: 72px;
  object-fit: contain;
}

.logo::after {
  content: "";
  width: 1px;
  height: 72px;
  background: rgba(88, 119, 186, 0.32);
  margin-left: 15.5px;
}

.logo_right {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 22px;
  margin-left: 23px;
  /* Internet Explorer 10 */
display:-ms-flexbox;
-ms-flex-pack:center;
-ms-flex-align:flex-start;

/* Firefox */
display:-moz-box;
-moz-box-pack:center;
-moz-box-align:flex-start;

/* Safari, Chrome, and Opera */
display:-webkit-box;
-webkit-box-pack:center;
-webkit-box-align:flex-start;

/* W3C */
display:box;
box-pack:center;
box-align:flex-start;
}

.logo_right img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.input_container {
  position: relative;
  display: flex;
  height: 40px;
}

.search {
  position: relative;
  display: flex;
  width: 240px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #999999;
  padding-left: 40px;
  box-sizing: border-box;
  font-size: 14px;
  color: #999999;
}

.input-icon {
  position: absolute;
  top: 8px;
  left: 12px;
  width: 24px;
  height: 24px;
}

.lineBox {
  width: 1px;
  height: 18px;
  margin-left: 24px;
  margin-top: 10px;
  background: #d8d8d8;
}

.phone_container {
  display: flex;
  justify-content: center;
  align-items: start;
  margin-left: 24px;
}

.phoneImg {
  width: 28px;
  height: 28px;
  line-height: 28px;
  margin-top: 4px;
}

.phone {
  font-size: 18px;
  margin-top: 5px;
  margin-left: 16px;
  color: #333333;
}

.nav {
  height: 64px;
  background-color: #13489d;
  line-height: 64px;
  color: #ffffff;
}

.tab_box {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  margin: 0px 142px;
}

.tabItem {
  text-align: center;
  display: flex;
  font-size: 16px;
  /* justify-content: space-around; */
}

.tabItem:hover {
  cursor: pointer;
}

.line1 {
  width: 20px;
  /* height: 5px; */
}

.line {
  transition: all 0.2s;
  /* animation: border-animate 0.3s; */
  bottom: 0px;
  left: 0px;
  position: absolute;
  /* width: 20px;
        height: 20px; */
  background: rgba(255, 255, 255, 1);
}

.tabItem1 {
  border-bottom: 2px solid white;
}
</style>